
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorOffHorisontal as ObiMotorOffHorisontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-off-horisontal.js';
 
 
 

 
 export const ObiMotorOffHorisontal = createComponent({
   react: React,
   tagName: 'obi-motor-off-horisontal',
   elementClass: ObiMotorOffHorisontalElement,
   events: {
     
   }
  });
 
 